/**
 * Sidebar Scroll Management
 * Handles scrolling active nav items into view when page loads
 */

export const initSidebarScroll = () => {
  const sidebar = document.getElementById('admin-sidebar');
  if (!sidebar) return;

  try {
    const content = sidebar.querySelector('.sidebar-content') || sidebar;

    // pick the deepest/last active nav-item (leaf) so parent active items don't override
    const activeItems = Array.from(sidebar.querySelectorAll('.nav-item.active'));
    const activeItem = activeItems.length ? activeItems[activeItems.length - 1] : null;
    // prefer the anchor inside the item if present (more accurate bounding box)
    const activeLink = activeItem?.querySelector('.nav-link') || activeItem;

    if (activeLink && content) {
      const contentRect = content.getBoundingClientRect();
      const linkRect = activeLink.getBoundingClientRect();
      // compute link center relative to content's scroll top
      const linkCenter = linkRect.top - contentRect.top + linkRect.height / 2;
      const targetScrollTop = content.scrollTop + linkCenter - content.clientHeight / 2;
      // clamp to valid range
      const maxScroll = Math.max(0, content.scrollHeight - content.clientHeight);
      const finalScroll = Math.max(0, Math.min(maxScroll, targetScrollTop));
      // ensure content is scrollable element (HTMLElement) before calling scrollTo
      if (typeof content.scrollTo === 'function') {
        content.scrollTo({ top: finalScroll, behavior: 'auto' });
      } else {
        // fallback for Elements without scrollTo
        content.scrollTop = finalScroll;
      }
    }
  } catch {
    // fail silently
  }
};
